<template lang="pug">
  #archived-emails-table
    WtEntityTable(
      title=""
      has-title-large
      :data="_.get(archivedEmailObject, 'data', [])"
      :pagination-object="archivedEmailObject ? archivedEmailObject.pagination : null"
      :fetch-action="fetchAction"
      default-sort-field="id"
      empty-message="No archived emails."
      :showEmptyMessage="!loading"
    )
      BTableColumn(
        field="subject"
        label="Subject"
        v-slot="column"
        sortable
      )
        BTooltip(
          label="View Email"
          position="is-top"
          animated
        )
          WtButton(
            is-text
            @click.native="openModal(column.row)"
          ) {{ column.row.subject }}
      BTableColumn(
        field="sentOn"
        label="Sent On"
        v-slot="column"
        sortable
      ) {{ date(column.row.sentOn, "DATE_TIME_FORMAT").formatted }}
      BTableColumn(
        field="filter"
        label="Sent To"
        v-slot="column"
        sortable
      ) {{ sentToText(column.row) }}
    BModal(
      :active.sync="emailModalOpen"
      :width="600"
    )
      MemberCenterAdminEmailArchiveModal(@emailModalOpen="emailModalOpen = $event" :email="emailModalObject" :featuredChallenges="featuredChallenges")
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import MemberCenterAdminEmailArchiveModal from "@@/MemberCenterAdmin/MemberCenterAdminEmailArchiveModal";

export default {
  name: "MemberCenterAdminEmailArchiveTable",

  components: { WtEntityTable, WtButton, MemberCenterAdminEmailArchiveModal },

  mixins: [tablePropsMixin, dateUtilityMixin],

  props: {
    archivedEmailObject: {
      type: Object,
      required: true
    },

    fetchAction: {
      type: Function,
      required: true
    },

    loading: {
      type: Boolean,
      required: true
    },

    featuredChallenges: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      emailModalOpen: false,
      emailModalObject: {}
    };
  },
  methods: {
    openModal(email) {
      this.emailModalObject = email;
      this.emailModalOpen = true;
    },
    sentToText(email) {
      switch (email.filter) {
        case "allMembers":
          return "All";
        case "atRiskMembers":
          return "No Activity";
        case "inFeaturedChallenge":
          return `In ${this.getChallengeName(email.featuredChallengeSelected)}`;
        case "notInFeaturedChallenge":
          return `Not in ${this.getChallengeName(
            email.featuredChallengeSelected
          )}`;
        case "individualUsers":
          return "Individuals";
        default:
          return "Members";
      }
    },

    getChallengeName(challengeId) {
      const challenge = this.featuredChallenges.find(
        el => el.id === challengeId
      );
      return this._.get(challenge, "name", null);
    }
  }
};
</script>

<style lang="sass" scoped></style>
